import { Badge } from "@/components/ui/badge";
import { money } from "@/lib/format";

/** Started vs quoted per service, plus why sessions fell back. */
export const ServiceBreakdown = ({ stats, maxServiceCount }) => (
  <div className="tt-card mt-4 p-5" data-testid="admin-service-breakdown">
    <h2 className="tt-eyebrow">By service</h2>
    <div className="mt-4 grid grid-cols-1 gap-5 md:grid-cols-3">
      {stats.by_service.map((row) => (
        <div key={row.service}>
          <div className="flex items-baseline justify-between gap-2">
            <p className="text-sm font-semibold text-foreground">{row.service_label}</p>
            <p className="font-amount text-sm font-bold text-primary">
              {row.quotes_total} quoted
            </p>
          </div>
          <div className="tt-ledger-track mt-2">
            <span
              className="tt-ledger-fill"
              style={{
                width: `${Math.max(
                  3,
                  Math.round((row.sessions_started / maxServiceCount) * 100),
                )}%`,
              }}
            />
          </div>
          <p className="mt-2 text-xs text-muted-foreground">
            {row.sessions_started} started · {row.quotes_week} this week · {row.quotes_month} this
            month
          </p>
          <p className="mt-0.5 font-amount text-xs font-semibold text-muted-foreground">
            {money(row.value_total)} quoted in total
          </p>
        </div>
      ))}
    </div>

    {stats.fallback_reasons?.length ? (
      <div className="mt-6 border-t border-border pt-4">
        <h3 className="tt-eyebrow">Why sessions fell back</h3>
        <div className="mt-3 flex flex-wrap gap-2">
          {stats.fallback_reasons.map((reason) => (
            <Badge
              key={reason.code}
              variant="outline"
              className="border-[color:var(--tt-warn-border)] bg-[color:var(--tt-warn-bg)] font-normal text-[color:var(--tt-warn-text)]"
            >
              {reason.code} · {reason.count}
            </Badge>
          ))}
        </div>
      </div>
    ) : null}
  </div>
);
